import store from "@/store";
import config from "@/config";
import { logout } from "@/store/slices/auth/authSlice";
import storage from "./storage";
import { getCookie } from "./generic.methods";

let isRedirectScheduled = false;

export const globalLogout = (shouldRedirect = false) => {
  console.log("on logout");
  const hostDomain = JSON.parse(storage.getItem("Profile"))?.HostDomain;
  const smarthubUser = getCookie("smarthub-user");
  console.log("smarthubUser", smarthubUser);

  let originUrl = globalThis?.window?.location?.origin || "";
  let currentUrl = "";

  if (config.environment === "development") {
    currentUrl = config.customerPortalURL.replace("my.", "");
  } else {
    currentUrl = originUrl.replace("smarthub.", "") + "/";
  }
  const url = hostDomain || currentUrl;
  store.dispatch(logout());

  // RouteGuard / interceptors re-call after cookies are cleared; only the first
  // redirect may run, or legacy Logout.aspx cancels the frontdoor navigation.
  if (shouldRedirect && url && !isRedirectScheduled) {
    isRedirectScheduled = true;
    if (smarthubUser) {
      const portalLogoutURL = `${config.frontdoorApiUrl}/api/auth/logout`;
      setTimeout(() => {
        window.location.href = portalLogoutURL;
      }, 1000);
    } else {
      let legacyURL =
        url + `/Pages/Logout.aspx?isNewPortalRedirect=true&isCRMRedirect=true`;
        setTimeout(() => {
        window.location.href = legacyURL;
      }, 1000);
    }
  }
};
